import { Form, Formik } from "formik";
import { validationForm } from "./ValidationForm"
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import CustomTextField from "../CustomFields/CustomTextField";
import { CP_INVALIDO, FECHA_VALIDA, INTER_CONTRATANE, MAX_LENGTH_CP, MAYOR_EDAD, TIPO_FLUJO } from "../Utils/Constantes";
import { useEffect, useState } from "react";
import CustomDatePickerLab from "../CustomFields/CustomDatePickerLab";
import { calcularEdad, generoValueToService, maxLength, serviceToGeneroValue, validaMayorEdad, validaResponse } from "../Utils/Utils";
import CustomErrorMessage from "../CustomFields/CustomErrorMessage";
import clsx from 'clsx';
import { useNavigate } from "react-router";
import Api from '../../components/Api/Api';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function Datos(props) {
  const navigate = useNavigate();
	const [datos, setDatos] = useState(null);
	const [isLoading, setLoading] = useState(true);
	const [pasoGenero, setPasoGenero] = useState(false);
	const [pasoCP, setPasoCP] = useState(false);
	const [pasoEmbarazo, setPasoEmbarazo] = useState(false);
	const [cotizar, setCotizar] = useState(false);

	const handleChangeFechaNacimiento = (fecha, setFieldValue, setFieldError) => {
		setCotizar(false);
		setFieldValue("genero", null);
		setPasoGenero(false);
		setFieldValue('embarazo', null);
		setPasoEmbarazo(false);
		setFieldValue('cp','');
		setPasoCP(false);
		if (fecha instanceof Date && !isNaN(fecha)) {
			setFieldValue("fechaNacimiento", fecha);
			if (validaMayorEdad(fecha)) {
				setPasoGenero(true);
			} else {
				setFieldError("fechaNacimiento", MAYOR_EDAD);
			}
		} else {
			setFieldError("fechaNacimiento", FECHA_VALIDA);
		}
	};

	const handleGenero = (genero, setFieldValue, values) => {
		setFieldValue('embarazo', null);
		setFieldValue('cp','');
		setPasoEmbarazo(false);
		setPasoCP(false);
		setFieldValue("genero", genero);
		if(genero === 0){
			setPasoCP(true);
			setFieldValue('cp','');
			setPasoEmbarazo(false);
		} else {
			//validacion pregunta embarazo
			if(calcularEdad(values.fechaNacimiento) > 10 && calcularEdad(values.fechaNacimiento) < 55){
				setPasoEmbarazo(true);
			} else {
				setPasoCP(true);
			}
		}
	};

	const handleEmbarazo = (embarazo, setFieldValue) => {
		setFieldValue("embarazo", embarazo);
		setPasoCP(true);
	};

	const handleChangeCP = (event, setFieldValue, setFieldError) => {
		const cp = maxLength(event.target.value, MAX_LENGTH_CP);
		setFieldValue("cp", cp);
		if(cp.length === MAX_LENGTH_CP){
			Api.validaCP(cp)
			.then(res => {
				if(validaResponse(res) && res.data.existe){
					setCotizar(true);
				} else {
					setFieldError('cp',CP_INVALIDO);
				}
			})
			.catch(error => {
				console.log(error);
			});
		} else {
			setCotizar(false);
		}
	};

	const handleContinuar = (values, setSubmitting) => {
    let contratante = {}, aseguradoTitular = {};
    const tipoFlujo = Number(window.sessionStorage.getItem(TIPO_FLUJO) ? window.sessionStorage.getItem(TIPO_FLUJO): props.tipoFlujo);
    if(window.sessionStorage.getItem(INTER_CONTRATANE)){
      contratante = JSON.parse(window.sessionStorage.getItem(INTER_CONTRATANE));
			contratante.fechaNacimiento = values.fechaNacimiento;
			contratante.genero = generoValueToService(values.genero);
			contratante.embarazo = values.embarazo;
			contratante.cp = values.cp;
      contratante.ultimoPaso = 1;
      contratante.tipoFlujo = tipoFlujo;
			aseguradoTitular.fechaNacimiento = values.fechaNacimiento;
			aseguradoTitular.genero = generoValueToService(values.genero);
			aseguradoTitular.embarazo =  values.embarazo;
			aseguradoTitular.cp = values.cp;
			aseguradoTitular.nombre = contratante.nombre;
			aseguradoTitular.telefono = contratante.telefono;
			aseguradoTitular.correo = contratante.correo;
			aseguradoTitular.titular = true;
			aseguradoTitular.indice = 0;
			//aseguradoTitular.parentesco = "Titular";
			contratante.asegurados = [].concat(aseguradoTitular);
			window.sessionStorage.setItem(INTER_CONTRATANE, JSON.stringify(contratante));	
			if(calcularEdad(new Date(values.fechaNacimiento)) > 70) {
				props.handleAdvertencias(1, true);
			} else 
			if(values.genero === 1 && values.embarazo) {
				props.handleAdvertencias(2, true);
			} else {
				Api.actualizaContratante(contratante.id, contratante)
				.then(res => {
					Api.getContratante(contratante.folio)
					.then(res => {
						window.sessionStorage.setItem(INTER_CONTRATANE,JSON.stringify(res.data.contratante));
						setSubmitting(false);
						switch (tipoFlujo) {
							case 1:
								//para mi
								navigate('/cotizacion');
								break;
							case 2:
								//pm y am
								navigate('/datos/alguien-mas');
								break;
							default:
								break;
						}
					})
					.catch(error => {
						setSubmitting(false);
						console.log(error);
					});
				})
				.catch(error => {
          setSubmitting(false);
					console.log(error);
				});
			}
    }
	};
	
	useEffect(() => {
    if(window.sessionStorage.getItem(INTER_CONTRATANE)){
			const contratante = JSON.parse(window.sessionStorage.getItem(INTER_CONTRATANE));
			if(contratante.fechaNacimiento){
				setDatos(contratante);
				setCotizar(true);
				setPasoGenero(true);
				if(serviceToGeneroValue(contratante.genero) === 1){
					setPasoEmbarazo(true);
				}
				setPasoCP(true);
			}
			setLoading(false);
		}
		/* Especifica cómo sanear este efecto:
		return function cleanup() {
		};*/
	}, []);
	
	return (
		<>
			{ isLoading ? <CircularProgress /> :
				<>
					<IconButton className="back-button" onClick={props.handleRegresar}>
						<ArrowBackIcon/>
					</IconButton>
					<Formik validateOnChange={true}
						initialValues={{
							fechaNacimiento: (datos && datos.fechaNacimiento ? new Date(datos.fechaNacimiento) : new Date()),
							genero: (datos && datos.genero ? serviceToGeneroValue(datos.genero) : null),
							embarazo: (datos ? datos.embarazo : null),
							cp: (datos && datos.cp ? datos.cp : null),
						}}
						onSubmit={(values, { setSubmitting }) => {
							setSubmitting(true);
							handleContinuar(values, setSubmitting);
						}}
						validationSchema={validationForm}>
						{({ values, submitForm, setFieldValue, handleChange, errors, isSubmitting, setFieldError }) => (
							<Form>
								<Grid container direction="row" justifyContent="center" alignItems="center" spacing={2} className="normalize-modal pX-60px">
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
										<p className="datos-txt">Ahora nos gustar&iacute;a saber un poco m&aacute;s de ti.</p>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
										<p >¿Cu&aacute;ndo naciste?</p>
										<CustomDatePickerLab id="fechaNacimiento" name="fechaNacimiento" type="text" placeholder="Fecha Nacimiento"
											className="grid-item-input w-100"
											disableFuture onChange={(newValue) =>
												handleChangeFechaNacimiento(newValue, setFieldValue, setFieldError)}
										/>
									</Grid>
									
									{pasoGenero && 
										<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
											<p className="mX-10">¿C&uacute;al es tu g&eacute;nero?</p>
											<Grid container direction="row" justifyContent="center" alignItems="center">
												<Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
													<Button variant="outlined" disableElevation
														className={clsx({"boton-form-seleccionado": (values.genero === 0)}, {"boton-form w-100":true})}
														onClick={(event) => handleGenero(0, setFieldValue, values)}>
														Hombre
													</Button>
												</Grid>
												<Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-end">
													<Button variant="outlined" disableElevation
														className={clsx({"boton-form-seleccionado": (values.genero === 1)}, {"boton-form w-100 d-flex flex-end":true})}
														onClick={(event) => handleGenero(1, setFieldValue, values)}>
														Mujer
													</Button>
												</Grid>
											</Grid>
										</Grid>
									}
									{pasoEmbarazo && 
										<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
											<p className="mX-10">¿Est&aacute;s embarazada?</p>
											<Grid container direction="row" justifyContent="center" alignItems="center">
												<Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
													<Button variant="outlined" disableElevation 
														className={clsx({"boton-form-seleccionado": (values.embarazo)}, {"boton-form w-100":true})}
														onClick={(event) => handleEmbarazo(true, setFieldValue)}>
														Si
													</Button>
												</Grid>
												<Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-end">
													<Button variant="outlined" disableElevation
														className={clsx({"boton-form-seleccionado": (values.embarazo === false)}, {"boton-form w-100":true})}
														onClick={(event) => handleEmbarazo(false, setFieldValue)}>
														No
													</Button>
												</Grid>
												<CustomErrorMessage name="embarazo"/>
											</Grid>
										</Grid>
									}
									{pasoCP && 
										<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
											<p className="fecha-nacimiento">¿C&uacute;al es tu c&oacute;digo postal?</p>
											<CustomTextField id="cp" name="cp" type="text" placeholder="C.P." className="grid-item-input"
												onChange={(event) => handleChangeCP(event, setFieldValue, setFieldError)}/>
										</Grid>
									}
									{cotizar &&
										<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
											<Button variant="outlined" disableElevation
												className="boton-submit boton-form-seleccionado" onClick={submitForm} disabled={isSubmitting}>
												COTIZAR
											</Button>
										</Grid>
									}
								</Grid>
							</Form>
						)}
					</Formik>
				</>
			 }
		</>
	);
}